//import Swal from "sweetalert2";
import { fetchConToken } from "../helpers/fetch";
//import { types } from "../types/types";
const KEY_RECAPTCHA = process.env.SECRET_KEY_RECAPTCHA;

export const getCategorias = async () => {
    try {
        const resp = await fetchConToken('web/api/categorias')
        //const resp = await fetchConToken('web/api/productos-categoria?categoriaCode=101&limit=10')
        const body = await resp.json();
        // console.log('getImportacion x', body);
        return body;
    } catch (error) {
        console.log(error)
        throw error
    }
};

export const getSliders = async () => {
    try {
        const resp = await fetchConToken('web/api/sliders')
        const body = await resp.json();
        //console.log('getImportacion x', body);
        return body;
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getProductosByCategoria = async (categoriaCode, limit = 10, page = 1, sortOrder = 'default') => {
    try {
        const url = `web/api/productos-categoria?categoriaCode=${categoriaCode}&limit=${limit}&page=${page}&sort=${sortOrder}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const getProductosFiltrados = async (
    categoriaCode,
    limit = 10,
    page = 1,
    marcaId,
    modeloprocesadorId,
    almacenamientoId,
    ramId,
    graficosId,
    precioMin,
    precioMax
) => {
    try {
        let url = `web/api/productos-con-filtros?categoriaCode=${categoriaCode}&limit=${limit}&page=${page}`;

        const filters = {
            marcaId,
            modeloprocesadorId,
            almacenamientoId,
            ramId,
            graficosId,
            precioMin,
            precioMax
        };

        Object.keys(filters).forEach((key) => {
            const value = filters[key];
            if (value !== undefined) {
                const paramValue = Array.isArray(value) ? value.join(',') : value;
                url += `&${key}=${paramValue}`;
            }
        });

        const resp = await fetchConToken(url);
        if (!resp.ok) {
            throw new Error(`Error: ${resp.status} - ${resp.statusText}`);
        }
        const body = await resp.json();
        if (!body || !body.productos) {
            throw new Error("No se encontraron productos en la respuesta.");
        }
        // console.log('Productos recibidos:', body);
        return body;
    } catch (error) {
        console.error("Error en la solicitud:", error);
        throw error;
    }
};


export const getProducto = async (sku) => {
    try {
        const url = `web/api/producto?sku=${sku}`;
        const resp = await fetchConToken(url)
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getMasVendidos = async () => {
    try {
        const resp = await fetchConToken('web/api/mas-vendidos')
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getOfertas = async () => {
    try {
        const resp = await fetchConToken('web/api/ofertas')
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getMarcas = async (categoriaCode) => {
    try {
        const url = `web/api/marcas?categoriaCode=${categoriaCode}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        console.log('body', body);
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};


export const getPrecioRango = async (categoriaCode) => {
    try {
        let url = 'web/api/precio-rango';
        if (categoriaCode) {
            url += `?categoriaCode=${categoriaCode}`;
        }
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getImagesByProductoId = async (productoId) => {
    try {
        const url = `web/api/producto/${productoId}/images`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        console.log('Imágenes del producto:', body);
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getProcesadores = async (categoriaCode) => {
    try {
        const url = `web/api/procesadores?categoriaCode=${categoriaCode}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getStorages = async (categoriaCode) => {
    try {
        const url = `web/api/storages?categoriaCode=${categoriaCode}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getGraficos = async (categoriaCode) => {
    try {
        const url = `web/api/graficos?categoriaCode=${categoriaCode}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getRams = async (categoriaCode) => {
    try {
        const url = `web/api/ram?categoriaCode=${categoriaCode}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getCategoriasPadres = async () => {
    try {
        const resp = await fetchConToken('web/api/categorias/padres');
        const body = await resp.json();
        // console.log('Categorías padres:', body);
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const searchProductos = async (query) => {
    try {
        const url = `web/api/productos/search/${query}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return body;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getAllProductos = async (limit = 10, page = 1, sortOrder = 'default') => {
    try {
        const url = `web/api/productos?limit=${limit}&page=${page}&sort=${sortOrder}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();
        return {
            productos: body.productos,
            total: body.total
        };
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const createSuscrito = async (correoClienteWeb, tipo) => {
    try {
        const data = {
            correoClienteWeb,
            tipo,
        };

        const resp = await fetchConToken('back/api/suscritos', data, 'POST');
        const body = await resp.json();

        if (resp.status === 201) {
            return body;
        } else {
            throw new Error(`Error al crear el suscrito: ${body?.message || 'Desconocido'}`);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const verifyRecaptcha = async (token) => {
    try {
        const url = 'https://www.google.com/recaptcha/api/siteverify'
        const formData = new URLSearchParams()
        formData.append("secret", KEY_RECAPTCHA)
        formData.append("response", token)

        const resp = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData
        })

        const data = await resp.json()
        return data.success
    } catch (error) {
        console.error("Error verificando reCAPTCHA:", error)
        return false
    }
}

export const mercadoPagoPreference = async (cartData) => {
    console.log('creando preferencia x', cartData)
    try {
        const resp = await fetchConToken('mercadopago/crear-preferencia', cartData, 'POST')
        const data = await resp.json()
        //console.log('🎯 Preferencia recibida:', data)
        return data
        // return data.init_point; //para pruebas
    } catch (error) {
        console.error("❌ Error al obtener la preferencia de Mercado Pago:", error)
        return null
    }
}

export const enviarCarrito = async (cartContext) => {
    try {
        const resp = await fetchConToken('web/api/carrito-compra', cartContext, 'POST')
        const data = await resp.json()
        //console.log('Carrito enviado:', data)
        return data
    } catch (error) {
        console.error("Error al enviar el carrito:", error)
        throw error
    }
}

export const validarCupon = async (codigoCupon) => {
    try {
        const url = `back/api/cupones/codigo/${codigoCupon}`;
        const resp = await fetchConToken(url);
        const body = await resp.json();

        if (!resp.ok) {
            throw new Error(body?.message || 'Cupón inválido');
        }

        return body;
    } catch (error) {
        console.error('Error al validar el cupón:', error);
        throw error;
    }
}

